import http from '@/utils/http'
import { networkData } from '@/utils/data'
import markingEnum from "@/utils/enums/markingEnum";

export const baseApi = {
  getAliOssToken: params => http.get("/marking-platform/ossUpload/get/fly/sts/token", params).then(resp => {
    return resp.body
  })
}

export const networkApi = {
  getWuHenRole: (params) => http.get('/marking-exam-grading/exam/grad/grading/role', params).then(resp => {
    if (resp.body) {
      resp.tabs = networkData.getRoleMenus(resp.body)
    }
    return resp
  }),
  gradingPreviewList: params => http.get("/marking-exam-grading/exam/grad/grading-preview", params),
  updateTeaGrading: params => http.post("/marking-main/exam/grad/update_tea_grading", params),
  getQuestionSchedule: params => {
    params.judgeType = markingEnum.MarkType[params.type]
    return http.get("/marking-exam-grading/monitor/teacher-grading-count", params)
  },
  listSubjectStand: (params) => http.get(`/marking-exam-manager/stand/${params.examId}/subjective`),
  getStudentMosaicPaper: (params, role) => http.put(`/marking-exam-manager/student-position/${role}/mosaic/url/${params.examId}/${params.resultId}?url=${params.url}`),
  getReadAvg: params => http.get('/marking-exam-grading/grad/score/avg', params),
  clearAllTask: params => http.post('/marking-exam-grading/clear-score/all', params),
  clearGroupTask: params => http.post("/marking-exam-grading/clear-score/group", params),
  clearQuestionScore: params => http.post("/marking-exam-grading/clear-score/group/by-judge-type", params),
  clearTeacherScore: params => http.post("/marking-exam-grading/clear-score/group/by-teacher", params)
}

//考试报告
export const wenliReportApi = {
  // 查询 school 的汇总分数线分析
  getTotal: params => http.get(`/marking-statistics-report/school/${params.type}/summary/total/${params.levelExamId}/${params.schoolId}`),
  // 根据 school 查询该学校的分数线分析
  getTotalDetail: params => http.get(`/marking-statistics-report/school/${params.type}/summary/map/${params.levelExamId}/${params.schoolId}`),
  // 基础指标分析
  basicIndexAnalysis: params => http.get(`/marking-statistics-report/school/${params.type}/basicIndexAnalysis/${params.levelExamId}/${params.schoolId}`),
  // 各班汇总报告-基础指标分析（汇总、单科）
  classIndexAnalysis: params => http.get(`/marking-statistics-report/school/${params.type}/classIndexAnalysis/${params.levelExamId}/${params.schoolId}?subjectCode=${params.subjectCode}`),
  // 各班单科等级占比分析
  levelComparison: params => http.get(`/marking-statistics-report/school/${params.type}/levelComparison/${params.levelExamId}/${params.schoolId}?subjectCode=${params.subjectCode}`).then(resp => {
    if (resp.body) {
      networkData.convertClassInfo(resp.body)
    }
    return resp
  }),
  // 成绩分析对比
  pageReportCard: params => http.post(`/marking-statistics-report/school/${params.type}/pageReportCard`, params),
  // 各班总分分数段对比
  sectionComparison: params => http.get(`/marking-statistics-report/school/${params.type}/sectionComparison/${params.levelExamId}/${params.schoolId}?subjectCode=${params.subjectCode}&sectionScore=${params.sectionScore}`).then(resp => {
    if (resp.body) {
      networkData.convertClassInfo(resp.body)
    }
    return resp
  }),
  // 各科目数据占比（汇总、单科）
  subjectIndexAnalysis: params => http.get(`/marking-statistics-report/school/${params.type}/subjectIndexAnalysis/${params.levelExamId}/${params.schoolId}?subjectCode=${params.subjectCode}`),
  // 各班名次对比
  rankingComparison: params => http.get(`/marking-statistics-report/school/${params.type}/rankingComparison/${params.levelExamId}/${params.schoolId}?subjectCode=${params.subjectCode}&beginRanking=${params.beginRanking}&endRanking=${params.endRanking}`).then(resp => {
    if (resp.body) {
      networkData.convertClassInfo(resp.body)
    }
    return resp
  }),
  // 各学科四分位数分析
  subjectStability: params => http.get(`/marking-statistics-report/school/${params.type}/subjectStability/${params.levelExamId}/${params.schoolId}`),
}


export const reportApi = {
  getCommendQuestions: params => http.post('/marking-question/public/recommend-question/search', params),
}

export const examApi = {
  copyExam: id => http.post('/marking-exam-manager/exam-list/reuse?examId=' + id),
  recoverExam: id => http.put('/marking-exam-manager/exam-list/recover/' + id),
  recycleExamList: params => http.post('/marking-exam-manager/exam-list/search/deleted', params),
}